import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsBeginYourStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="8347" id="understanding-your-rest" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612128/img/hand_writing_journal.png)]" />
        {}
        <div className="absolute inset-0 bg-primary/40 backdrop-brightness-50 !bg-[url(https://solutionsforsleepapnea.com/wp-content/uploads/2026/04/image-1.webp)]" />
      </div>

      {}
      <div className="container relative z-10 px-4 md:px-6 py-20 flex justify-center md:justify-start lg:pl-20 !bg-[url()]">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} max-w-xl w-full`}>
          <Card className="border-primary/20 bg-background/85 backdrop-blur-xl shadow-2xl overflow-hidden">
            <CardContent className="p-8 md:p-10 flex flex-col gap-6">
              <div className="space-y-4">
                <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.1] bg-gradient-to-r from-primary to-blue-900 bg-clip-text text-transparent">
                  Reclaim Your Nights
                </h1>
                <p className="text-lg text-muted-foreground leading-relaxed font-sans">
                  We understand how exhausting chronic sleep apnea can be. Our team is dedicated to providing specialized, empathetic care to help you restore your health and get the peaceful rest you deserve.
                </p>
              </div>

              <div className="pt-2">
                <Button asChild size="lg" className="rounded-full px-8 h-12 text-base shadow-lg hover:shadow-accent/20 transition-all duration-300 bg-accent text-accent-foreground hover:bg-accent/90 animate-pulse">
                  <Link to="#">
                    Get a Free Consultation
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}